import { useConst } from './useConst';

let id = 1;

export const useId = (prefix = 'id') => {
    return useConst(() => prefix + id++);
};
